import React from 'react';
import ReactDOM from 'react-dom';
import 'react-notifications/lib/notifications.css';
import App from './components/App';
import registerServiceWorker from './registerServiceWorker';
import './components/layout/global.css';
import './utils/polyfils';



ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();
